"use client";

import { FC, ReactNode, useEffect } from "react";
import Gleap from "gleap";

export const GleapInit: FC<{ children?: ReactNode }> = ({ children }) => {
  useEffect(() => {
    Gleap.initialize(process.env.NEXT_PUBLIC_GLEAP_API_KEY!);
  }, []);

  return <>{children}</>;
};
